// extracted by mini-css-extract-plugin
export default {"content":"Information_content__gvOC+","buttons":"Information_buttons__tY93V","bannerContainer":"Information_bannerContainer__vi6Nt","bannerButton":"Information_bannerButton__7ommL"};